import { Component } from '@angular/core';
import { Campaign } from './../../models/newsletter/campaigns.model';
import { CommunicationService } from './../../shared/services/communication.service';
import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';

@Component({
  selector: 'swb-campaigns-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html',
})
export class CampaignsListComponent extends ListBase<Campaign> {

  public url = 'campaigns';
  public routePrefix = 'campaigns';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    )
  }
}
